import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import Profile from '@/pages/Profile'

export const Route = createFileRoute('/profile')({
  ...requireCompleteProfile(),
  component: Profile,
})